export default {
  manual: 'manualList',
  lastday: 'lasdayList',
  lastweek: 'lastweekList',
  lastmonth: 'lastmonthList',
};
